module.exports = __webpack_public_path__ + "img/level_logo2.73cdeed4.png";